export const MENSAGENS_AGENDADAS_DESIGN = {
    page: {
        root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
        fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
        container: 'w-full px-4 md:px-6 lg:px-8',
        pageBody: 'pb-[120px] flex-1 min-h-0 flex flex-col',
        stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
        topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
        topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
        iconTile:
            'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
        headerTitle: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
        headerSubtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
        topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
        primaryButton:
            'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
        filterBar: 'flex flex-wrap items-end gap-3 mb-3',
        filterItem: 'min-w-0',
        filterLabel: 'text-[10px] font-semibold text-[#a1a1aa] uppercase tracking-wider mb-1 block',
        filterSelect:
            'h-9 w-[150px] md:w-[170px] text-xs rounded-lg border border-[#d4d4d8] bg-white px-3 text-[#18181b] shadow-none hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
        filterSearchWrap: 'relative min-w-[180px] w-[200px] md:w-[240px]',
        filterSearch:
            'h-9 w-full pl-9 pr-3 text-xs rounded-lg border border-[#d4d4d8] bg-white text-[#18181b] shadow-none placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
        searchIcon: 'absolute left-3 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none',
        tabsBar: 'flex items-center gap-1 mb-4 border-b border-[#e7e7ec] overflow-x-auto',
        tabBtn: 'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap',
        tabBtnActive: 'border-[#7C3AED] text-[#7C3AED]',
        tabBtnIdle: 'border-transparent text-[#71717a] hover:text-[#18181b]',
        contentWrapper: 'flex-1 min-h-0 flex flex-col',
        card: 'bg-white border border-[#e7e7ec] rounded-[12px] flex flex-col overflow-hidden flex-1 min-h-0',
    },
    table: {
        root: 'table-fixed w-full min-w-[980px]',
        header: 'bg-[#fafafb] sticky top-0 z-10',
        headCell: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa] h-12 whitespace-nowrap',
        row: 'hover:bg-[#fafafb] transition-colors border-b border-[#f0f0f3] last:border-0',
        cell: 'px-3 py-3 text-sm text-[#18181b] align-middle',
        contentCell: 'max-w-0 overflow-hidden',
        contentText: 'block truncate text-sm text-gray-600',
        nowrapCell: 'whitespace-nowrap',
        actionsCell: 'w-[96px] text-right',
        statusBadge: {
            base: 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
            active: 'bg-green-100 text-green-800',
            inactive: 'bg-gray-100 text-gray-800',
        },
    },
    dialog: {
        content: 'flex flex-col gap-0 p-0 w-full sm:max-w-[800px] h-[90vh] sm:h-[800px] max-h-[90vh] rounded-xl overflow-hidden bg-white shadow-2xl',
        header: 'px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-white shrink-0',
        title: 'text-xl font-bold text-gray-900',
        body: 'flex-1 overflow-y-auto px-6 py-6 scroll-smooth',
        footer: 'px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-between items-center shrink-0',
        sectionTitle: 'text-lg font-medium text-gray-900 mb-1',
        sectionSubtitle: 'text-sm text-gray-500 mb-6',
        formGrid: 'grid grid-cols-1 gap-6',
        label: 'block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2',
    },
};
